import { Divider, Form, Progress, Select } from "antd";
import React, { useRef, useState } from "react";
import img1 from "../../assets/img/img1.png";
import img2 from "../../assets/img/img2.png";
import img3 from "../../assets/img/img3.png";
import svg7 from "../../assets/svg/svg7.svg";

const items = [
  {
    svg: "img1",
    count: "97.89%",
    title: "Sanitation Coverage",
    svgSub: "svg7",
    progress: [
      {
        titleProgress: "Personal Expenditure as % of O/M",
        percentage: 80,
      },
      {
        titleProgress: "O+M Cost Coverage",
        percentage: 62,
      },
    ],
  },
    {
    svg: "img2",
    count: "90.89%",
    title: "Water Coverage",
    svgSub: "svg7",
    progress: [
      {
        titleProgress: "Supply Hours",
        percentage: 96,
      },
      {
        titleProgress: "Metering",
        percentage: 10,
      },
    ],
  },

   {
    svg: "img3",
    count: "12.89%",
    title: "Sewarage Coverage",
    svgSub: "svg7",
    progress: [
      {
        titleProgress: "Collection Efficiency",
        percentage: 96,
      },
      {
        titleProgress: "Staff Productivity",
        percentage: 60,
      },
    ],
  },
];
function DashboardFy() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [selectId, setSelectId] = useState(null);

  const svgMap = {
    img1,
    img2,
    img3,
    svg7,
  };
  const processedData = items?.map((item) => ({
    ...item,
    svg: svgMap[item?.svg],
    svgSub: svgMap[item?.svgSub],
  }));
  return (
    <div className="white_card mt-[1.5rem] flex-1 min-h-[50vh]">
      <div className="flex items-center justify-between">
        <span className="text-[#2D3E8D] font-appleAlt text-[1.5rem] font-[600]">
          Dashboard FY-2023-2024
        </span>
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          className="lg:w-[10%] w-full"
          form={form}
        >
          <div className="w-full banner-select flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Year</span>
            <Select
              className="banner-selector"
              allowClear
              style={{
                width: "100%",
              }}
              //   options={
              //     dataPathway?.length > 0 &&
              //     dataPathway?.map((item) => ({
              //       value: item?.irrigationPathwayId,
              //       label: item?.irrigationPathwayName,
              //     }))
              //   }
              value={selectId}
              onChange={(value) => setSelectId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>
        </Form>
      </div>
      <div className="mt-[-1rem]">
        <Divider />
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[3.69rem]">
        {processedData &&
          processedData?.map((item) => (
            <div className="h-full lg:w-[28rem] w-full p-[.5rem] ">
              <div className="flex gap-x-[2.25rem]">
                <img
                  src={item?.svg}
                  alt={item?.svg}
                  className="object-contain"
                />
                <div className="flex flex-col">
                  <span className="text-[#424242] font-appleAlt text-[2.1875rem] font-[800]">
                    {item?.count}
                  </span>
                  <span className="flex items-center text-[#424242] text-[1rem] font-[400] font-appleAlt gap-x-2">
                    {item?.title} <img src={item?.svgSub} alt={item?.svgSub} />
                  </span>
                </div>
              </div>

              <div className="mt-[2.75rem]">
                {item?.progress &&
                  item?.progress?.map((detail) => (
                    <div className="flex flex-col text-[#424242] font-appleAlt text-[1rem] font-[400] mt-[1rem]">
                      <span>{detail?.titleProgress}</span>
                      <Progress
                        strokeColor="#569D6E"
                        percent={detail?.percentage}
                      />
                    </div>
                  ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default DashboardFy;
